import React, { useCallback, useEffect, useMemo } from 'react';
import { Button, Card, Col, Row, Skeleton, Typography } from 'antd';
import router from 'umi/router';
import { connect } from 'dva';
import { QuestionCircleOutlined } from '@ant-design/icons';
import CreatePlaybook from './CreatePlaybook';
import moment from 'moment';
import PlaybooksList from './PlaybooksList';
import { getFilteredPlaybooks, getDescription } from './helpers';
import { PATH_DASHBOARD } from '@/utils/routes/path';
const { Title } = Typography;

/**
 * @description - This component list playbooks associated with resource or risk
 * and navigate a user to create a playbook for currently opened signature or resource.
 * @param {String} signature - optional - currently selected signature
 * @param {String} resource - optional - current selected resource
 * @param {String} service - current service
 * @param {Array} cloudAccounts - cloud accounts list
 * @param {Object[]} playbooksList - List of all playbooks
 * @returns
 */
function Playbooks({
  signature,
  service,
  cloudAccounts,
  resource,
  playbooksList,
  playbooksLoading,
  playbookTemplatesLoading,
  dispatch,
}) {
  useEffect(() => {
    console.log('CDM Playbooks from universal');
    // Get playbooks list
    dispatch({ type: 'editor/list' });

    // Get playbook templates
    dispatch({
      type: 'editor/getTemplateList',
    });
  }, []);

  // Handler for Create Playbook button
  const onCreate = () => {
    // Get cloud accounts ids only.
    let cloudAccountsIds = cloudAccounts.map(cloudAccount => cloudAccount.id);

    // Send prefilled data to playbook editor
    dispatch({
      type: 'editor/save',
      payload: {
        templateId: 'default',
        selectedTrigger: 'newRisk',
        prefilledData: {
          cloudAccount: cloudAccountsIds,
          service: [service],

          // Check for optional fields, service and resource.
          ...(signature && { signatures: [signature] }),
          ...(resource && { resources: [resource] }),
        },
      },
    });

    // Navigate to create playbook
    router.push(PATH_DASHBOARD.playbooks.editor);
  };

  // Handler for View Playbook button
  const onViewPlaybook = record => {
    // Empty playbook editor data
    dispatch({
      type: 'editor/save',
      payload: {
        current: null,
        templateId: '',
        playbookResult: {},
        playbookDetail: {
          name: 'Untitled-1',
          description: '',
          isActive: false,
        },
      },
    });

    // Navigate to view playbook
    router.push(`${PATH_DASHBOARD.playbooks.editor}/${record.id}`);
  };

  // Get playbooks for current resource or risk
  let filteredPlaybooks = useMemo(
    () => getFilteredPlaybooks(playbooksList, cloudAccounts, signature, resource, service),
    [playbooksList, resource, signature, service]
  );

  if (playbooksLoading || playbookTemplatesLoading) {
    return <Skeleton avatar={false} className="w-100 ml-4 mr-4 mt-2" />;
  }

  // Render playbook list , if playbooks exist for current resource or risk
  if (filteredPlaybooks.length > 0) {
    return (
      <PlaybooksList
        playbooksList={filteredPlaybooks}
        description={getDescription(signature)}
        onCreate={onCreate}
        onViewPlaybook={onViewPlaybook}
        signature={signature}
      />
    );
  }

  return <CreatePlaybook description={getDescription(signature)} onCreate={onCreate} />;
}

export default connect(({ editor }) => ({
  playbooksList: editor.list,
  playbooksLoading: editor.listLoading,
  playbookTemplatesLoading: editor.playbookTemplatesLoading,
}))(Playbooks);
